export const CONFIRMATION_QUESTION = 'Are you sure you want to remove this recording?';
